






























import { Component, Vue, Prop } from 'vue-property-decorator';
import { STORE_URL } from '@/constants';

@Component({
  name: 'CLButton',
})
export default class CLButton extends Vue {
  @Prop()
  outlined!: boolean;

  @Prop()
  blue!: boolean;

  @Prop()
  small!: boolean;

  @Prop()
  disabled!: boolean;

  @Prop()
  isStoreLink!: boolean;

  storeUrl: string = '';

  created() {
    this.storeUrl = STORE_URL;
  }

  get btnClasses() {
    let classes = '';
    if (this.blue !== undefined) {
      classes += 'btn-blue';
    }
    if (this.outlined !== undefined) {
      classes += ' btn-outlined';
    }
    if (this.small !== undefined) {
      classes += ' btn-small';
    }
    return classes;
  }

  get isDisabled() {
    if (this.disabled === true) return true;
    return false;
  }
}
